export class FontAwesomeConfigurations {
  // custom
  public static ICON_SETTINGS_CONNECTIVITY_TAB = 'fa-regular fa-signal';
  public static ICON_SETTINGS_AUDIO_TAB = 'fa-regular fa-speakers';
  public static ICON_SETTINGS_VIDEO_TAB = 'fa-regular fa-video';
  public static ICON_SETTINGS_STATUS_BAD = 'fa-light fa-circle-exclamation';
  public static ICON_SETTINGS_STATUS_GOOD = 'fa-light fa-circle-check';

  public static ICON_CE_NOT_CLAIMED = 'fa-regular fa-book';
  public static ICON_CE_CLAIMED = 'fa-solid fa-book';

  public static ICON_EPOSTER = 'fa-solid fa-chalkboard-user';
  // session types
  public static ICON_MAINSTAGE = 'fa-regular fa-images-user';
  public static ICON_PANEL = 'fa-solid fa-screen-users';
  public static ICON_BREAKOUT = 'fa-solid fa-users-viewfinder';

  // brands
  public static ICON_FACEBOOK_F = 'fa-brands fa-facebook-f';
  public static ICON_TWITTER = 'fa-brands fa-twitter';
  public static ICON_INSTAGRAM = 'fa-brands fa-instagram';
  public static ICON_LINKEDIN = 'fa-brands fa-linkedin';

  // defaults
  public static ICON_ADDRESS_BOOK = 'fa-regular fa-address-book';
  public static ICON_ARROW_DOWN = 'fa-regular fa-arrow-down';
  public static ICON_ARROW_LEFT = 'fa-regular fa-arrow-left';
  public static ICON_ARROW_RIGHT = 'fa-regular fa-arrow-right';
  public static ICON_ARROW_RIGHT_FROM_BRACKET = 'fa-solid fa-arrow-right-from-bracket';
  public static ICON_ARROW_UP = 'fa-regular fa-arrow-up';
  public static ICON_ARROW_UP_RIGHT_FROM_SQUARE = 'fa-regular fa-arrow-up-right-from-square';
  public static ICON_UPRIGHT_DOWNLEFT_FROMCENTER_SOLID = 'fa-solid fa-up-right-and-down-left-from-center';
  public static ICON_AWARD = 'fa-regular fa-award';
  public static ICON_ATTENDEES = 'fa-regular fa-users';
  public static ICON_BAN = 'fa-regular fa-ban';
  public static ICON_BARS = 'fa-regular fa-bars';
  public static ICON_BARS_SORT_DUOTONE = 'fa-duotone fa-bars-sort';
  public static ICON_BELL = 'fa-regular fa-bell';
  public static ICON_BORDER_ALL = 'fa-regular fa-border-all';
  public static ICON_BOOKMARK = 'fa-regular fa-bookmark';
  public static ICON_BOOK_OPEN_READER = 'fa-regular fa-book-open-reader';
  public static ICON_BULLHORN_SOLID = 'fa-solid fa-bullhorn';
  public static ICON_CALENDAR_CIRCLE_PLUS = 'fa-regular fa-calendar-circle-plus';
  public static ICON_CALENDAR_DAYS = 'fa-regular fa-calendar-days';
  public static ICON_CALENDAR_LINES = 'fa-regular fa-calendar-lines';
  public static ICON_CAMERA_ROTATE = 'fa-regular fa-camera-rotate';
  public static ICON_CAMERA_SLASH = 'fa-regular fa-camera-slash';
  public static ICON_CARET_DOWN = 'fa-regular fa-caret-down';
  public static ICON_CARET_UP = 'fa-regular fa-caret-up';
  public static ICON_CHART_BAR = 'fa-regular fa-chart-bar';
  public static ICON_CHECK = 'fa-regular fa-check';
  public static ICON_CHEVRON_DOWN = 'fa-regular fa-chevron-down';
  public static ICON_CHEVRON_LEFT = 'fa-regular fa-chevron-left';
  public static ICON_CHEVRON_RIGHT = 'fa-regular fa-chevron-right';
  public static ICON_CHEVRON_UP = 'fa-regular fa-chevron-up';
  public static ICON_CIRCLE_CHECK = 'fa-regular fa-circle-check';
  public static ICON_CIRCLE_DOT = 'fa-regular fa-circle-dot';
  public static ICON_CIRCLE_INFO = 'fa-regular fa-circle-info';
  public static ICON_CIRCLE_INFO_SOLID = 'fa-solid fa-circle-info';
  public static ICON_CIRCLE_HALF_STROKE = 'fa-regular fa-circle-half-stroke';
  public static ICON_CIRCLE_PAUSE = 'fa-regular fa-circle-pause';
  public static ICON_CIRCLE_PLAY = 'fa-regular fa-circle-play';
  public static ICON_CIRCLE_PLUS = 'fa-regular fa-circle-plus';
  public static ICON_CIRCLE_REGULAR = 'fa-regular fa-circle';
  public static ICON_CIRCLE_SMALL = 'fa-solid fa-circle-small';
  public static ICON_CIRCLE_SOLID = 'fa-solid fa-circle';
  public static ICON_CIRCLE_QUESTION = 'fa-regular fa-circle-question';
  public static ICON_CIRCLE_XMARK = 'fa-regular fa-circle-xmark';
  public static ICON_CLOCK = 'fa-regular fa-clock';
  public static ICON_COMMENT = 'fa-regular fa-comment';
  public static ICON_COMMENT_LINES_SOLID = 'fa-solid fa-comment-lines';
  public static ICON_COMMENT_CHECK_DUOTONE = 'fa-duotone fa-comment-check';
  public static ICON_COMMENTS_DUOTONE = 'fa-duotone fa-comments';
  public static ICON_COMPRESS = 'fa-regular fa-compress';
  public static ICON_DISPLAY = 'fa-regular fa-display';
  public static ICON_DESKTOP = 'fa-regular fa-desktop';
  public static ICON_DOOR_OPEN = 'fa-regular fa-door-open';
  public static ICON_DOWNLEFT_UPRIGHT_TOCENTER_SOLID = 'fa-solid fa-down-left-and-up-right-to-center';
  public static ICON_DOWNLOAD = 'fa-regular fa-download';
  public static ICON_ELLIPSIS_VERTICAL = 'fa-regular fa-ellipsis-vertical';
  public static ICON_ENVELOPE = 'fa-regular fa-envelope';
  public static ICON_ERASER = 'fa-regular fa-eraser';
  public static ICON_EXPAND = 'fa-regular fa-expand';
  public static ICON_EYE = 'fa-regular fa-eye';
  public static ICON_FOLDER_ARROW_DOWN_SOLID = 'fa-solid fa-folder-arrow-down';
  public static ICON_FOLDER_OPEN = 'fa-regular fa-folder-open';
  public static ICON_FILTERS = 'fa-regular fa-filters';
  public static ICON_FILTERS_LIST_SOLID = 'fa-solid fa-filter-list';
  public static ICON_GALLERY_THUMBNAILS = 'fa-regular fa-gallery-thumbnails';
  public static ICON_GEAR = 'fa-regular fa-gear';
  public static ICON_GEAR_SOLID = 'fa-solid fa-gear';
  public static ICON_GRADUATION_CAP = 'fa-regular fa-graduation-cap';
  public static ICON_GRID = 'fa-regular fa-grid';
  public static ICON_GRIP_VERTICAL = 'fa-regular fa-grip-vertical';
  public static ICON_HAND = 'fa-regular fa-hand';
  public static ICON_HANDSHAKE = 'fa-regular fa-handshake';
  public static ICON_IMAGES = 'fa-regular fa-images';
  public static ICON_LIGHTBULB = 'fa-regular fa-lightbulb';
  public static ICON_LINK = 'fa-regular fa-link';
  public static ICON_LIST_CHECK = 'fa-regular fa-list-check';
  public static ICON_LIST_TREE_SOLID = 'fa-solid fa-list-tree';
  public static ICON_LOCATION_DOT_SOLID = 'fa-solid fa-location-dot';
  public static ICON_LOCK_KEYHOLE = 'fa-regular fa-lock-keyhole';
  public static ICON_LOCK_KEYHOLE_SOLID = 'fa-solid fa-lock-keyhole';
  public static ICON_MEDAL = 'fa-regular fa-medal';
  public static ICON_MEMO_CIRCLE_CHECK_LIGHT = 'fa-light fa-memo-circle-check';
  public static ICON_MEMO_CIRCLE_INFO_LIGHT = 'fa-light fa-memo-circle-info';
  public static ICON_MESSAGE = 'fa-regular fa-message';
  public static ICON_MESSAGE_LINES_SOLID = 'fa-solid fa-message-lines';
  public static ICON_MESSAGES_QUESTION_DUOTONE = 'fa-duotone fa-messages-question';
  public static ICON_MICROPHONE_LINES = 'fa-regular fa-microphone-lines';
  public static ICON_NEWSPAPER = 'fa-regular fa-newspaper';
  public static ICON_PAINTBRUSH = 'fa-regular fa-paintbrush';
  public static ICON_PAPERCLIP = 'fa-regular fa-paperclip';
  public static ICON_PAUSE = 'fa-regular fa-pause';
  public static ICON_PEN = 'fa-regular fa-pen';
  public static ICON_PEN_CIRCLE_DUOTONE = 'fa-duotone fa-pen-circle';
  public static ICON_PERSON_TO_DOOR_DUOTONE = 'fa-duotone fa-person-to-door';
  public static ICON_PHONE = 'fa-regular fa-phone';
  public static ICON_PLAY = 'fa-regular fa-play';
  public static ICON_PLUS = 'fa-regular fa-plus';
  public static ICON_POINTSBOLT = 'fa-regular fa-bolt-lightning';
  public static ICON_POINTSBOLT_SOLID = 'fa-sharp fa-solid fa-bolt-lightning';
  public static ICON_RIGHT_LEFT = 'fa-regular fa-right-left';
  public static ICON_SCREWDRIVER_WRENCH = 'fa-duotone fa-screwdriver-wrench';
  public static ICON_SHIELD_KEYHOLE_SOLID = 'fa-solid fa-shield-keyhole';
  public static ICON_SHUFFLE = 'fa-regular fa-shuffle';
  public static ICON_SIGNAL = 'fa-regular fa-signal';
  public static ICON_SLASH = 'fa-regular fa-slash';
  public static ICON_SPEAKER = 'fa-regular fa-speaker';
  public static ICON_SPEAKERS_DUOTONE = 'fa-duotone fa-speakers';
  public static ICON_SQUARE_PEN = 'fa-regular fa-square-pen';
  public static ICON_SQUARE_PLUS = 'fa-regular fa-square-plus';
  public static ICON_SQUARE_STAR = 'fa-solid fa-square-star';
  public static ICON_STAR = 'fa-regular fa-star';
  public static ICON_STAR_SOLID = 'fa-solid fa-star';
  public static ICON_TABLE_CELLS = 'fa-regular fa-table-cells';
  public static ICON_TAG = 'fa-regular fa-tag';
  public static ICON_TEXT_SIZE = 'fa-regular fa-text-size';
  public static ICON_THUMBTACK_DUOTONE = 'fa-duotone fa-thumbtack';
  public static ICON_THUMBS_UP = 'fa-regular fa-thumbs-up';
  public static ICON_TRASH_DUOTONE = 'fa-duotone fa-trash';
  public static ICON_TROPHY_SOLID = 'fa-solid fa-trophy';
  public static ICON_TROPHY_STAR = 'fa-regular fa-trophy-star';
  public static ICON_UNIVERSAL_ACCESS = 'fa-regular fa-universal-access';
  public static ICON_USER = 'fa-regular fa-user';
  public static ICON_USER_CIRCLE = 'fa-regular fa-user-circle';
  public static ICON_USER_GROUP = 'fa-solid fa-user-group';
  public static ICON_USER_PEN = 'fa-regular fa-user-pen';
  public static ICON_USER_PLUS = 'fa-regular fa-user-plus';
  public static ICON_USERS = 'fa-regular fa-users';
  public static ICON_VIDEO = 'fa-regular fa-video';
  public static ICON_VOLUME_HIGH = 'fa-regular fa-volume-high';
  public static ICON_VOLUME_LOW = 'fa-regular fa-volume-low';
  public static ICON_VOLUME_SLASH = 'fa-regular fa-volume-slash';
  public static ICON_VOLUME_XMARK = 'fa-regular fa-volume-xmark';
  public static ICON_XMARK = 'fa-regular fa-xmark';
  public static ICON_XMARK_TO_SLOT = 'fa-regular fa-xmark-to-slot';

  public static ICON_FACE_SMILE = 'fa-regular fa-face-smile'; //change styles?

  public static ICON_THUMBS_UP_REGULAR = 'fa-regular fa-thumbs-up';
  public static ICON_COMMENT_REGULAR = 'fa-regular fa-comment';
  public static ICON_COMMENTS_REGULAR = 'fa-regular fa-comments';
  public static ICON_PLAY_SOLID = 'fa-solid fa-play';
  public static ICON_ARROW_DOWN_TO_BRACKET = 'fa-solid fa-arrow-down-to-bracket';
  public static ICON_MINUS = 'fa-regular fa-minus';

  public static ICON_HAND_CLAP = {
    class: 'fa-duotone fa-hands-clapping fa-swap-opacity',
    primary: 'white',
    secondary: '#ffd868',
    secondary_opacity: '0.4',
  };
  public static ICON_FACE_ASTONISHED = {
    class: 'fa-duotone fa-face-astonished fa-swap-opacity',
    primary: 'black',
    secondary: '#ffd969',
    secondary_opacity: '0.4',
  };
  public static ICON_FACE_BEAM = {
    class: 'fa-duotone fa-face-laugh-beam fa-swap-opacity',
    primary: 'black',
    secondary: '#ffd969',
    secondary_opacity: '0.4',
  };
  public static ICON_FACE_SAD_CRY = {
    class: 'fa-duotone fa-face-sad-cry fa-swap-opacity',
    primary: 'black',
    secondary: '#ffd969',
    secondary_opacity: '0.4',
  };
  public static ICON_FACE_SMILE_PLUS = {
    class: 'fa-duotone fa-face-smile-plus fa-swap-opacity',
    primary: 'white',
    secondary: '#ffd969',
    secondary_opacity: '0.4',
  };
  public static ICON_DISPLAY_SLASH = {
    class: 'fa-duotone fa-display-slash',
    primary: 'var(--brand-color-bad)',
    secondary: 'white',
    secondary_opacity: '0.7',
  };
  public static ICON_MICROPHONE_LINES_SLASH = {
    class: 'fa-duotone fa-microphone-lines-slash',
    primary: 'var(--brand-color-bad)',
    secondary: 'white',
    secondary_opacity: '0.7',
  };
  public static ICON_VIDEO_SLASH = {
    class: 'fa-duotone fa-video-slash',
    primary: 'var(--brand-color-bad)',
    secondary: 'white',
    secondary_opacity: '0.7',
  };
  public static ICON_THUMBS_UP_DUOTONE = {
    class: 'fa-duotone fa-thumbs-up',
    primary: '#538dff',
    secondary: 'white',
  };
  public static ICON_CIRCLE_HEART = {
    class: 'fa-duotone fa-circle-heart fa-swap-opacity',
    primary: 'white',
    secondary: 'var(--brand-color)',
  };
  public static ICON_ROTATE = {
    class: 'fa-duotone fa-swap-opacity fa-solid fa-rotate',
    primary: 'gray',
  };
}
